module.exports = __webpack_public_path__ + "static/media/BLUSH_6531.3a8c04da.jpg";